module.exports = __webpack_public_path__ + "static/media/IconTemplates_-52.1a1f3e74.svg";